<template></template>

<script type="text/javascript">
const swebip    ="https://www.whytobook.com/";
const sserverip = "https://www.whytobook.com/btobser/";
// const swebip = "http://172.18.0.63:8080/";
// const sserverip = "http://172.18.0.63:8081/btobser/";
// elasticsearch查询sku地址
//const ssearskuip = "http://47.119.186.42:9200/xibcbmssku/_doc/_search";
// const ssearskuip = "http://localhost:9200/xibcbmssku/_doc/_search";
//elasticsearch的购物车相关地址
// const sskucartip = "http://47.119.186.42:9200/skucart/_doc";
// const sskucartip = "http://localhost:9200/skucart/_doc";
const AEScode = "xibc2020wtjt0817";

import axios from "axios";
import AES from "./AES.js";

export default {
  swebip,
  sserverip,
  // ssearskuip,
  // sskucartip,
  AEScode,

  //空值转空字符串
  convertToEmptyString(value) {
    return value == null ? "" : value; // 注意这里是宽松相等比较，同时检查null和undefined
  },
  //加逗号，如果两个字符串都非空就加个逗号。
  addcomma(bsr, estr) {
    if (bsr == "" && estr == "") {
      return "";
    } else if (bsr == "" && estr != "") {
      return estr;
    } else if (bsr != "" && estr == "") {
      return bsr;
    } else if (bsr != "" && estr != "") {
      return bsr + " , " + estr;
    }
  },
  //字符串非空就在最后加逗号
  addcommawhennotnull(bsr) {
    if (bsr == "") {
      return "";
    } else {
      return bsr + " , ";
    }
  },

  getcxSummaries(setupsummary, param) {
    // TO-DO 重构思路，原来的写法有点乱
    // 在模块的data中设置常量数组【】，指定要Summary的字段序号及内容
    // 数组元素为三元数组，如
    // setupsummary: [
    // [1, "总计"],
    // [5, "sum", "个",0],
    // [6, "sumby", "元",0],
    // ......],
    // 第二个元素为“sum”的直接累计；为“sumby”的和第四个元素对应的字段的相乘后累计
    //其他直接赋予内容
    //一次循环后得到所有需要Summar的总值，统一用sums[index] = "";赋值
    // TO-DO isNaN用于判断是否数值型，以后可以改的更智能些，不用设置setupsummary的值也能正常运作。

    const { columns, data } = param;
    const sums = [];
    if (data.length > 0) {
      var sconfig = setupsummary;
      sconfig.forEach((column, index) => {
        if (sconfig[index][1] === "sum") {
          var iloop = sconfig[index][0];
          var sfield = columns[iloop].property;
          sums[iloop] = 0;
          data.forEach((column, index) => {
            sums[iloop] = sums[iloop] + data[index][sfield];
          });
          sums[iloop] = sums[iloop] + sconfig[index][2];
        } else if (sconfig[index][1] === "sumby") {
          var iloopby = sconfig[index][0];
          var sfieldby = columns[iloopby].property;
          var iloopbyby = sconfig[index][3];
          var sfieldbyby = columns[iloopbyby].property;
          sums[iloopby] = 0;
          data.forEach((column, index) => {
            sums[iloopby] =
              sums[iloopby] + data[index][sfieldby] * data[index][sfieldbyby];
          });
          sums[iloopby] = sums[iloopby].toFixed(2) + sconfig[index][2];
        } else {
          sums[sconfig[index][0]] = sconfig[index][1];
        }
      });
    }

    /*
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (index === 4) {
          sums[index] = "";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

      console.log('values');
      console.log(values);

// console.log(column);
        //console.log(values);
        // 在这里处理非选择不合计

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += " 元";
        } else {
          sums[index] = "";
        }
      });
*/
    return sums;
  },

  dateFormat(time, sformat) {
    var date = new Date(time);
    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    // 拼接
    if (sformat === "yyyy-mm-dd hh:mm:ss") {
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    } else if (sformat === "yyyy-mm-dd") {
      return year + "-" + month + "-" + day;
    } else if (sformat === "yyyymmdd") {
      return year + month + day;
    }
  },

  //当购物车中不存在时，放入购物车；当购物车中存在时，返回。
  putchartifnull(row) {
    var stoken = window.localStorage.getItem("stoken");

    var ssskuid = row.skuid;
    let that = this;
    var cartdata = new Object();
    cartdata = row;
    cartdata.id = ssskuid;
    cartdata.inum = 1;
    var scustid = AES.decrypt(
      window.localStorage.getItem("scustomerid"),
      AEScode
    );
    cartdata.scustomerid = scustid;
    cartdata.sremark = "";

    var reqbody = new Object();
    reqbody.field1 = scustid + ssskuid;
    reqbody.field2 = JSON.stringify(cartdata);

    axios({
      // headers: {
      //   "Content-type": "application/json",
      // },
      // method: "PUT",
      // url: sskucartip + "/" + ssskuid + "/_create",
      // data: cartdata,
      headers: { "Content-type": "application/json", token: stoken },
      method: "post",
      url: sserverip + "putShopcartToES",
      data: JSON.stringify(reqbody),
    })
      .then(function (res) {
        //TO-DO 先判断下数据是否正确 status
        console.log("update ok ");
        console.log(res);
      })
      .catch(function (err) {
        console.log(
          "如果相同的 _index 、 _type 和 _id 的文档已经存在，create操作 将会返回 409 Conflict 响应码"
        );
        console.log(err);
      });
  },
};
</script>
